import { css, useTheme } from '@emotion/react';

import { ReactNode } from 'react';

import { Radius, Spacing } from 'chatie-design-system';

import { CSSProps, OnClickProps } from '../../utils/misc';
import Pad from '../layout/Pad';

type BoxProps = {
  color?: string;
  backgroundColor?: string;
  borderColor?: string;
  icon?: ReactNode;
  children?: ReactNode;
};

const messageBoxCSS = css`
  border-radius: ${Radius.small}px;
`;

const messageBoxContentCSS = css`
  display: flex;
  align-items: center;

  > div:nth-of-type(1) {
    flex-shrink: 1;
    font-size: 0;

    i {
      margin-right: ${Spacing.xsmall}px;
    }
  }

  > div:nth-of-type(2) {
    flex-grow: 1;
  }
`;

export const MessageBox = ({
  className,
  icon,
  color,
  borderColor,
  backgroundColor,
  children,
  onClick,
}: BoxProps & CSSProps & OnClickProps) => {
  const theme = useTheme();

  return (
    <Pad
      css={messageBoxCSS}
      className={className}
      size={Spacing.small}
      color={color ?? theme.var.gray800}
      borderColor={borderColor}
      backgroundColor={backgroundColor ?? theme.var.gray100}
      onClick={onClick}
    >
      <div css={messageBoxContentCSS}>
        <div>{icon}</div>
        <div>{children}</div>
      </div>
    </Pad>
  );
};
